export default () => window.apmApp;
